import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../../base-types";

@JsonObject()
export class BucketResponseResource {
    @JsonProperty("key")
    key: string;

    @JsonProperty("original_key")
    originalKey: string;

    @JsonProperty("count")
    count: Nullable<number> = null;

    @JsonProperty("metric")
    metric: Nullable<number> = null;

    @JsonProperty("buckets")
    @JsonElementType(BucketResponseResource)
    buckets: Array<BucketResponseResource> = [];
}
